export default __webpack_public_path__ + "69c267a5f8f8c9c1b2c37a68c2d2f4ba.svg";